/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_OpenInputs */

const en_btn_open = /** @type {(inputs: Btn_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open`)
};

const ar_btn_open = /** @type {(inputs: Btn_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فتح`)
};

const de_btn_open = /** @type {(inputs: Btn_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öffnen`)
};

const es_btn_open = /** @type {(inputs: Btn_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir`)
};

const fr_btn_open = /** @type {(inputs: Btn_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrir`)
};

const it_btn_open = /** @type {(inputs: Btn_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apri`)
};

const ja_btn_open = /** @type {(inputs: Btn_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開ける`)
};

const ko_btn_open = /** @type {(inputs: Btn_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`열기`)
};

const pt_br_btn_open = /** @type {(inputs: Btn_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir`)
};

const ru_btn_open = /** @type {(inputs: Btn_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Открыть`)
};

const th_btn_open = /** @type {(inputs: Btn_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เปิด`)
};

const tr_btn_open = /** @type {(inputs: Btn_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aç`)
};

const zh_cn_btn_open = /** @type {(inputs: Btn_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开启`)
};

const zh_tw_btn_open = /** @type {(inputs: Btn_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開啟`)
};

/**
* | output |
* | --- |
* | "Open" |
*
* @param {Btn_OpenInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const btn_open = /** @type {((inputs?: Btn_OpenInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_OpenInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_btn_open(inputs)
	if (locale === "ar") return ar_btn_open(inputs)
	if (locale === "de") return de_btn_open(inputs)
	if (locale === "es") return es_btn_open(inputs)
	if (locale === "fr") return fr_btn_open(inputs)
	if (locale === "it") return it_btn_open(inputs)
	if (locale === "ja") return ja_btn_open(inputs)
	if (locale === "ko") return ko_btn_open(inputs)
	if (locale === "pt_br") return pt_br_btn_open(inputs)
	if (locale === "ru") return ru_btn_open(inputs)
	if (locale === "th") return th_btn_open(inputs)
	if (locale === "tr") return tr_btn_open(inputs)
	if (locale === "zh_cn") return zh_cn_btn_open(inputs)
	return zh_tw_btn_open(inputs)
});